import { render, staticRenderFns } from "./ButtonControl.vue?vue&type=template&id=70116d22&"
import script from "./ButtonControl.vue?vue&type=script&lang=js&"
export * from "./ButtonControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports